import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

const round = defineStyle({
  borderRadius: "100%"
});

export const closeButtonTheme = defineStyleConfig({
  variants: { round },
});
